import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';

/**
 * Layout for public pages (landing, login, register)
 * No sidebar, full-width content
 */
export function PublicLayout() {
    return (
        <Box sx={{ minHeight: '100vh' }}>
            <Header onToggleSidebar={() => {}} />
            <Outlet />
        </Box>
    );
}

export default PublicLayout;
